import Hero from "../components/hero";
import Main from "../components/main";
import BlogSection from "../components/blogSection";
import Subscriber from "../components/subscriber";
import Footer from "../components/footer";
import NavBar from "../components/nav";
import SubHeroSection from "./sub-hero";
import PlacesToVisitInKimberley from "./placesToVist";

const Home = () => {
  return (
    <div className="home-page">
      <NavBar />
      <Hero />
      <section className="home-journey-section">
        <SubHeroSection />
      </section>

      <Main />
      <PlacesToVisitInKimberley />
      <BlogSection />
      <Subscriber />
      <Footer />
    </div>
  );
};

export default Home;
